import { useState, MouseEvent } from "react";
import { IconButton, Menu } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";

import MenuItem from "./item";
import * as styles from "./styles";

export { MenuItem };

type Props = {
  children(options: { withClose: (callBack?: () => void) => () => void }): React.ReactNode;
};

export default function IconMenu({ children }: Props) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const withClose = (callBack?: () => void) => {
    return () => {
      handleClose();
      callBack?.();
    };
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <IconButton
        onClick={handleClick}
        aria-controls={open ? "icon-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        aria-label="delete"
      >
        <MoreVertIcon />
      </IconButton>

      <Menu
        id="icon-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          elevation: 0,
          ...styles.menu,
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {children({ withClose })}
      </Menu>
    </>
  );
}
